module.exports = __webpack_public_path__ + "img/king_ict.e6620374.png";